<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center h-20 pt-6 px-8">
        <img
          class="w-24"
          src="images/logo/logo.webp"
          alt="Logo image">
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  }

  <!-- Wrapper -->
  <div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 text-md items-center w-full h-10 sm:h-12 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
      @if (!isScreenSmall) {
        <!-- Logo -->
        <div class="flex items-center mx-2 lg:mr-8" >
          <div class="hidden lg:flex" [routerLink]="route">
            <img
              class="dark:hidden h-6 w-40 modern-logo"
              src="images/logo/logo.webp">
              <img
                class="hidden dark:flex h-7 w-40 modern-logo"
                src="images/logo/logo2.webp">
              </div>
              <!-- <img
              class="flex lg:hidden w-8"
              src="images/logo/logo.svg"> -->
            </div>
            <!-- Horizontal navigation -->
            <fuse-horizontal-navigation
              class="mr-2 "
              [name]="'mainNavigation'"
            [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
          }
          <!-- Navigation toggle button -->
          @if (isScreenSmall) {
            <button
              mat-icon-button
              (click)="toggleNavigation('mainNavigation')">
              <mat-icon class="svgs" [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
          }
          <!-- Components -->
          <div class="flex items-center pl-1 ml-auto space-x-1 sm:space-x-1">
            @if (is) {
              <div class="relative">
                <mat-icon matTooltip="{{isIsView ? 'Switch to employee view' : 'Switch to Supervisor view'}}" class="mb-2 cursor-pointer" svgIcon="mat_outline:flip" (click)="switchPage()"></mat-icon>
                <!-- <img class="absolute top-[-10px] left-[-25px]" src="assets\\images\\logo\\new.png" style="height: 30px; width: 30px;"> -->
              </div>
            }
            @if (bundy && (device=='Windows' || device=='Mac OS X')) {
              <app-bundy></app-bundy>
            }
            <languages></languages>
            <dark-light></dark-light>
            <fuse-fullscreen ></fuse-fullscreen>
            <user></user>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button> -->
          <!-- <mat-menu #menu="matMenu">
          <languages (click)="$event.stopPropagation();$event.preventDefault();"></languages>
          <shortcuts (click)="$event.stopPropagation();$event.preventDefault();"></shortcuts>
          <messages (click)="$event.stopPropagation();$event.preventDefault();"></messages>
          <notifications (click)="$event.stopPropagation();$event.preventDefault();"></notifications>
        </mat-menu> -->
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto w-full">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>

    <!-- Footer -->
    <div class="relative flex flex-0 items-center w-full h-7 sm:h-10 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
      <span class="font-medium text-secondary">AanyaHR &copy; {{currentYear}} &#8226; {{companyname}}</span>
    </div>

  </div>


